import { DownloadRecordType } from '@drift/common';

/**
 * Uses a function so that it can automatically append new years.
 */
export const getExportHistoryPeriods = () => {
	const exportHistoryPeriods = [
		{
			label: 'This week',
			value: 'week',
		},
		{
			label: 'This month',
			value: 'month',
		},
		{
			label: 'Last 3 months',
			value: '3mo',
		},
		{
			label: 'Year to date',
			value: 'ytd',
		},
		{
			label: 'Last 12 months',
			value: 'year',
		},
		{
			label: '2022',
			value: 'custom_1',
		},
		{
			label: '2023',
			value: 'custom_2',
		},
		{
			label: '2024',
			value: 'custom_3',
		},
	];

	const currentYear = new Date().getFullYear();

	while (
		parseInt(exportHistoryPeriods[exportHistoryPeriods.length - 1].label) <
		currentYear
	) {
		const nextCustomNum =
			parseInt(
				exportHistoryPeriods[exportHistoryPeriods.length - 1].value.split(
					'_'
				)[1]
			) + 1;

		const nextYear =
			parseInt(exportHistoryPeriods[exportHistoryPeriods.length - 1].label) + 1;

		exportHistoryPeriods.push({
			label: `${nextYear}`,
			value: `custom_${nextCustomNum}`,
		});
	}

	return exportHistoryPeriods;
};

export function getIsExportHistoryUserType(exportType: DownloadRecordType) {
	return [
		'trades',
		'deposits',
		'liquidations',
		'funding-payments',
		'settle-pnl-records',
		'lp-records',
		'swap-records',
	].includes(exportType);
}

export function getIsExportHistoryMarketType(exportType: DownloadRecordType) {
	return exportType === 'market-trades' || exportType === 'funding-rates';
}

export function filterExportHistoryPeriodsForType(
	exportPeriod: string,
	exportType: DownloadRecordType
) {
	// Market trades: allow week, month, and custom years (with month selection constraint handled separately)
	if (exportType === 'market-trades') {
		return (
			exportPeriod === 'week' ||
			exportPeriod === 'month' ||
			exportPeriod.includes('custom')
		);
	}

	// Funding rates (market specific) can use all periods
	if (exportType === 'funding-rates') {
		return true;
	}

	return (
		exportPeriod === 'week' ||
		exportPeriod === 'month' ||
		exportPeriod.includes('custom')
	);
}

/**
 * For market-trades with a custom year, a specific month must be selected (not "all months")
 * to ensure the timeframe is 31 days or less.
 * @param selectedPeriod - The selected period (e.g., 'week', 'month', 'custom_1')
 * @param selectedMonth - 0 for "all months", 1-12 for specific month
 * @returns true if the selection exceeds the 31 day limit for market-trades
 */
export function isMarketTradesTimeframeExceeded(
	selectedPeriod: string,
	selectedMonth: number
) {
	// Week and month are always within 31 days
	if (selectedPeriod === 'week' || selectedPeriod === 'month') {
		return false;
	}

	// Custom year with "all months" (0) exceeds 31 days
	if (selectedPeriod.includes('custom') && selectedMonth === 0) {
		return true;
	}

	// Custom year with specific month is within 31 days
	return false;
}
